import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c36f956"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-close-fill" }, null, -1))
const _hoisted_3 = { class: "title-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-paw" }, null, -1))
const _hoisted_5 = { class: "stake-content main-content" }

import {
  computed, ref,
} from 'vue';

import FarmDialogType from '@/types/token-farm';


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: Boolean,
  dTitle: {
    default: 'Dialog',
    type: String,
  },
},
  emits: ['update:visible', 'submit'],
  setup(__props, { emit }) {

const props = __props





const innerVisible = computed({
  get: () => props.visible,
  set: (val: boolean) => emit('update:visible', val),
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, _mergeProps({
    modelValue: _unref(innerVisible),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(innerVisible) ? (innerVisible).value = $event : null)),
    "custom-class": "neco-dialog",
    width: "600px",
    "show-close": false
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (innerVisible.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _renderSlot(_ctx.$slots, "title", {}, () => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(__props.dTitle), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ]),
    _: 3
  }, 16, ["modelValue"]))
}
}

})